const CATEGORY_CODE_BY_KEY = {
  ae: "afterEffects",
  pp: "premierePro",
  mg: "mogrt",
  am: "appleMotion",
  dr: "davinciResolve",
  gt: "graphicsTemplate",
};

const CATEGORY_KEYS = Object.keys(CATEGORY_CODE_BY_KEY);

export function getLastEndDate(subscription = {}) {
  const endDates = Array.isArray(subscription.end) ? subscription.end : [];
  if (!endDates.length) return null;
  const lastEnd = new Date(endDates[endDates.length - 1]);
  return Number.isNaN(lastEnd.getTime()) ? null : lastEnd;
}

export function isSubscriptionActive(subscription = {}) {
  if (typeof subscription.status === "boolean") {
    return subscription.status;
  }
  const lastEnd = getLastEndDate(subscription);
  return !!lastEnd && lastEnd >= new Date();
}

export function hasCategory(subscription = {}, key) {
  if (!subscription || !key) return false;

  const categories = Array.isArray(subscription.categories)
    ? subscription.categories
    : [];
  if (categories.length) {
    const code = CATEGORY_CODE_BY_KEY[key] || key;
    return categories.includes(code) || categories.includes(key);
  }

  if (typeof subscription[key] === "boolean") {
    return subscription[key];
  }

  return true;
}

export { CATEGORY_KEYS, CATEGORY_CODE_BY_KEY };
